module.exports = __webpack_public_path__ + "assets/img/profile-connections-active.fdefc6cd.svg";